// @flow
import React, { Component } from "react";
import I18n from "../../../../i18n/I18n";
import { Dropdown, Button } from "../../../common";
import WarehouseBox from "../warehouseBox/WarehouseBox";
import stylesParent from "../OfferDetails.scss";
import styles from "../warehouseBox/WarehouseBox.scss";

// type Props = {
//   name: string,
//   indeterminate: boolean
// };

class WarehouseSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id_warehouse: "",
      is_fbn: 0,
      processing_time: "1",
      quantity: 0,
      warehouse_city: "",
      warehouse_code: "",
      warehouse_priority: ""
    };
    this.addStock = this.addStock.bind(this);
  }
  dropdownChange(e: Object, key: any) {
    const newState = this.state;
    newState[`${key}`] = e.value.toString();
    const availableWarehouses =
      this.props.changedVariant &&
      this.props.changedVariant.available_warehouses
        ? this.props.changedVariant.available_warehouses
        : null;
    newState.is_fbn = this.state.id_warehouse
      ? availableWarehouses.filter(
          warehouse =>
            warehouse.id_warehouse === Number(this.state.id_warehouse)
        )[0].is_fbn
      : newState.is_fbn;
    newState.warehouse_code = this.state.id_warehouse
      ? availableWarehouses.filter(
          warehouse =>
            warehouse.id_warehouse === Number(this.state.id_warehouse)
        )[0].warehouse_code
      : newState.warehouse_code;
    newState.warehouse_city = this.state.id_warehouse
      ? availableWarehouses.filter(
          warehouse =>
            warehouse.id_warehouse === Number(this.state.id_warehouse)
        )[0].warehouse_city
      : newState.warehouse_city;
    this.setState(newState);
  }
  addStock(e: Object) {
    const newState = this.state;
    if (newState.id_warehouse.length) {
      this.props.onWarehouseChange(newState);
      this.props.toggleShowStockUpdate();
    }
  }
  valAppend = val => {
    this.setState({ ...val });
    this.props.valAppend(this.state);
  };
  render() {
    const {
      onWarehouseChange,
      changedVariant,
      valAppend,
      toggleShowStockUpdate,
      horizontal
    } = this.props;
    const warehouseOptions = [];
    changedVariant &&
      changedVariant.available_warehouses &&
      changedVariant.available_warehouses.map(warehouse => {
        warehouseOptions.push(
          Object.assign(
            {},
            { value: warehouse.id_warehouse, label: warehouse.warehouse_code }
          )
        );
      });
    return (
      <div
        className={`${styles.ctr} ${
          this.props.horizontal ? styles.flexer : ""
        } ${this.props.single ? styles.single : ""}`}
      >
        <h6 className={styles.attrTitle}>
          {I18n.getText("offers.choose-warehouse")}
        </h6>
        <div className={styles.dropdownWrapper}>
          {I18n.getComponent(
            formattedValue => (
              <Dropdown
                options={warehouseOptions}
                height="short"
                placeholder={formattedValue}
                value={this.state.id_warehouse}
                onChange={e => this.dropdownChange(e, "id_warehouse")}
              />
            ),
            "dropdown.select"
          )}
          <WarehouseBox
            horizontal={horizontal}
            isFbn={this.state.is_fbn}
            data={this.state}
            valAppend={this.valAppend}
          />
          <div className={stylesParent.btnWrapper}>
            <Button
              variant="transparent"
              className={stylesParent.cancelBtn}
              onClick={toggleShowStockUpdate}
            >
              {I18n.getText("offer.offer-cancel")}
            </Button>
            <Button className={stylesParent.btn} onClick={this.addStock}>
              {I18n.getText("offer.save")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default WarehouseSelect;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/warehouseSelect/WarehouseSelect.js